import { portalApi } from "@/redux/api";
import { InvitationRequestSource } from "@/features/invitations/types/invitation.type";
import type {
  CreateUsersRequest,
  InvitationDistinctOption,
  InvitationDistinctRole,
  InviteUsersResponse,
  UserPortalUpdateSelf,
  ValidateTokenUser
} from "@/features/invitations/types/invitation.type";

export const CREATE_INVITED_USERS_SEARCH =
  `send_invites=true&request_source=${InvitationRequestSource.PORTAL}` as const;

const ADMIN_USERS_ENDPOINT = "/admin/users";
const ADMIN_PUBLIC_INVITATIONS_ENDPOINT = "/admin/invitations";
const DISTINCT_BASE_ENDPOINT = "/portal_reports/distinct";

export const buildInvitationTokenPath = (
  token: string,
  action: "validate" | "accept"
): string =>
  `${ADMIN_PUBLIC_INVITATIONS_ENDPOINT}/${encodeURIComponent(token)}/${action}`;

export const invitationsApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    createInvitedUsers: builder.mutation<
      InviteUsersResponse,
      CreateUsersRequest
    >({
      query: (body) => ({
        url: `${ADMIN_USERS_ENDPOINT}?${CREATE_INVITED_USERS_SEARCH}`,
        method: "POST",
        body
      })
    }),
    getInvitationRoles: builder.query<InvitationDistinctRole[], void>({
      query: () => `${DISTINCT_BASE_ENDPOINT}/roles`
    }),
    getInvitationPartners: builder.query<InvitationDistinctOption[], void>({
      query: () => `${DISTINCT_BASE_ENDPOINT}/partners`
    }),
    getInvitationCompanies: builder.query<InvitationDistinctOption[], void>({
      query: () => `${DISTINCT_BASE_ENDPOINT}/companies`
    }),
    validateInvitationToken: builder.query<ValidateTokenUser, string>({
      query: (token) => buildInvitationTokenPath(token, "validate")
    }),
    acceptInvitation: builder.mutation<
      void,
      { token: string; body: UserPortalUpdateSelf }
    >({
      query: ({ token, body }) => ({
        url: buildInvitationTokenPath(token, "accept"),
        method: "POST",
        body
      })
    })
  })
});

export const {
  useCreateInvitedUsersMutation,
  useGetInvitationRolesQuery,
  useGetInvitationPartnersQuery,
  useGetInvitationCompaniesQuery,
  useValidateInvitationTokenQuery,
  useLazyValidateInvitationTokenQuery,
  useAcceptInvitationMutation
} = invitationsApi;
